module.exports = __webpack_public_path__ + "static/img/case_7.db8bf35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_7.jpg
// module id = dejc
// module chunks = 0